module.exports = __webpack_public_path__ + "img/28@2x.d4499cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/28@2x.png
// module id = 7XHu
// module chunks = 0